import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CarouselModule, MediaModule } from '@spartacus/storefront';

import { KnBrProductCarouselComponent } from './kn-br-product-carousel.component';

@NgModule({
    imports: [
        CommonModule,
        CarouselModule,
        MediaModule,
        RouterModule,
        UrlModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ProductCarouselComponent: {
                    component: KnBrProductCarouselComponent,
                },
            },
        } as CmsConfig),
        KnBrProductCarouselComponent,
    ],
    providers: [],
})
export class KnBrProductCarouselModule {}
